import { Autocomplete, DisplayModes } from '@coconut-software/ui';
import React, { useContext, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { POPULAR_COUNTRIES } from '../constants';
import { CountriesContext } from '../contexts/CountriesContext';
import { CountryContext } from '../contexts/CountryContext';

const DesktopCountryPicker = () => {
  const intl = useIntl();
  const countries = useContext(CountriesContext);
  const [country, setCountry] = useContext(CountryContext);
  const [search, setSearch] = useState('');

  const options = useMemo(() => {
    const allOptions = search
      ? Object.entries(countries)
          .filter(([, label]) =>
            label.toLowerCase().includes(search.toLowerCase()),
          )
          .map(([id, label]) => ({ id, label }))
      : Object.entries(countries).map(([id, label]) => ({ id, label }));

    const sortedOptions = allOptions.reduce(
      (acc, option) => {
        if (POPULAR_COUNTRIES.includes(option.id)) {
          acc.popular.push(option);
        } else {
          acc.all.push(option);
        }
        return acc;
      },
      { popular: [], all: [] },
    );

    return [sortedOptions.popular, sortedOptions.all];
  }, [countries, search]);

  const handleOnChange = (event) => {
    if (event?.currentTarget?.value === country) {
      return;
    }

    setSearch(event.target.value);
  };

  return (
    <Autocomplete
      defaultDisplayValue={countries[country] ?? ''}
      defaultValue={country}
      label={intl.formatMessage({ id: 'CountryTimezoneModal.country_label' })}
      name="country"
      onChange={handleOnChange}
      onSelect={(event) => setCountry(event?.currentTarget?.value)}
      select
    >
      <>
        {options.map((group, index) => (
          <Autocomplete.Group
            display={DisplayModes.Always}
            key={index === 0 ? 'popular' : 'all'}
            label={
              index === 0
                ? intl.formatMessage({ id: 'CountryTimezoneModal.common' })
                : intl.formatMessage({ id: 'CountryTimezoneModal.countries' })
            }
          >
            {group.map((option) => (
              <Autocomplete.Suggestion key={option.id} value={option.id}>
                {option.label}
              </Autocomplete.Suggestion>
            ))}
          </Autocomplete.Group>
        ))}
      </>
    </Autocomplete>
  );
};

export default DesktopCountryPicker;
